import React, { useCallback, FC, useState } from 'react';
import { useLocation } from 'react-router-dom';
// components
import UploadFileModal from 'components/file-cabinet-folders/modals/upload-file-modal';
// mui components
import { Box, Typography, Grid } from '@mui/material';
// api
import { useGetCompanyRolePermissionsMeQuery } from 'redux-store/api/company-roles';
import { FileCabinetUserPermission } from 'redux-store/api/file-cabinet';
// helpers
import { checkUserAddAccess } from 'utils/helpers/fileCabinetHelpers';
// icons
import FolderIcon from 'assets/icons/cabinet/file.svg';
// styles
import { styles } from './styles';

type EmptyListProps = {
  fromModal: boolean;
  projectFolderId?: string | number;
  projectId: string | number;
  myPermissions: FileCabinetUserPermission;
};

const EmptyList: FC<EmptyListProps> = ({
  fromModal,
  projectId,
  projectFolderId,
  myPermissions,
}) => {
  const [isOpenUploadFile, setIsOpenUploadFile] = useState(false);
  const { data: userPermissions } = useGetCompanyRolePermissionsMeQuery();
  const { pathname, hash } = useLocation();

  const isRootLevel = pathname?.includes('file-cabinet') || !hash;

  const addAccess = checkUserAddAccess(
    false,
    userPermissions?.CREATE_FOLDERS?.canRead,
    myPermissions,
    isRootLevel
  );

  const handleOpenModal = useCallback(() => {
    setIsOpenUploadFile(true);
  }, []);

  const handleCloseModal = useCallback(() => {
    setIsOpenUploadFile(false);
  }, []);

  return (
    <Box sx={styles.container}>
      <FolderIcon />
      <Typography sx={styles.typo}>There are no files yet.</Typography>
      <Typography sx={styles.typo}>Drag & drop your file here</Typography>
      <Typography sx={styles.typo}>or</Typography>
      {addAccess && (
        <Grid onClick={handleOpenModal} sx={styles.backLink}>
          Upload Files
        </Grid>
      )}

      {isOpenUploadFile && (
        <UploadFileModal
          canCreateFolders={userPermissions?.CREATE_FOLDERS?.canCreate}
          open={isOpenUploadFile}
          handleClose={handleCloseModal}
          projectFolderId={projectFolderId}
          fromModal={fromModal}
          projectId={projectId}
        />
      )}
    </Box>
  );
};

export default EmptyList;
